import isApiError from "@insite/client-framework/Common/isApiError";
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { addWishListLines } from "@insite/client-framework/Services/WishListService";
import {
    AddLineToWishList,
    AddToWishListParameter,
    chain,
} from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { buildConfiguratorLineInput } from "@tSurya/Common/MgbwConfiguratorHelpers";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";

type ProductInfoWithProperties = AddToWishListParameter["productInfos"][number] & {
    properties?: Record<string, string>;
};

type HandlerType = Handler<AddToWishListParameter, { result: { wishList?: WishListModel; errorMessage?: string } }>;

export const AddLineToWishListWithProperties: HandlerType = async props => {
    if (!props.result.wishList) {
        return;
    }

    try {
        const lines = props.parameter.productInfos.map(productInfo => {
            const pi = productInfo as ProductInfoWithProperties;
            const properties = { ...(pi.properties || {}), ...buildConfiguratorLineInput(pi.properties) };

            return {
                productId: pi.productId,
                qtyOrdered: pi.qtyOrdered,
                unitOfMeasure: pi.unitOfMeasure,
                ...(Object.keys(properties).length > 0 ? { properties } : {}),
            };
        });
        await addWishListLines({ wishList: props.result.wishList, lines });
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        if (error?.status === 404) {
            props.result.errorMessage = error.errorMessage;
            return;
        }
        throw error;
    }
};

replaceInChain(chain, AddLineToWishList, AddLineToWishListWithProperties);
